import { render, staticRenderFns } from "./LegendOfDolly.vue?vue&type=template&id=4b7a19ee&scoped=true&"
import script from "./LegendOfDolly.vue?vue&type=script&lang=ts&"
export * from "./LegendOfDolly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a19ee",
  null
  
)

export default component.exports